import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { focus } from '@dojo/framework/core/middleware/focus';

import { Keys } from '@holmescorp/common';
import { lccstate } from '@holmescorp/lcc-state';
import { resourceTrackingChange } from '@holmescorp/lcc-state';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { I18nProperties, DefaultChildrenWNodeFactory } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { publish, subscribe } from '@holmescorp/pub-sub';

import css from '../css/resource-parser.m.css';
import { includes } from 'lodash-es';

export interface VideoButtonICache {
	focusedNode?: boolean;
}

export interface VideoButtonProperties {
	videoid: string;
	flags?: string[];
}

const icache = createICacheMiddleware<VideoButtonICache>();
const factory = create({ icache, focus, theme, lccstate }).properties<VideoButtonProperties>();
export const VideoButton = factory(({ children, properties, middleware: { icache, focus, theme, lccstate } }) => {
	const { key, videoid, flags = [] } = properties();
	const themeCss = theme.classes(css);
	const act = `site/video/${videoid}`;
	const role = includes(flags, 'ariaRoleListitem') ? 'listitem button' : 'button';
	const widgetId = `video-${videoid}`;

	const focusedNode: boolean = icache.getOrSet('focusedNode', false) as boolean;
	subscribe('close/video', () => {
		const { get, path } = lccstate;
		const focusedWidgetId = get(path('resourceTracking')).widgetId;

		if (widgetId === focusedWidgetId) {
			console.info('(set focus): ', focusedWidgetId);
			icache.set('focusedNode', true);
		}
	});

	const maybeFocus = () => {
		if (focusedNode) {
			focus.focus();
		}
	};

	return v(
		'div',
		{
			widgetId,
			key,
			classes: [themeCss.videolink],
			tabIndex: 0,
			focus: focusedNode ? focus.shouldFocus : undefined,
			onFocus: maybeFocus(),
			role,
			onclick: (event) => {
				event.stopPropagation();
				resourceTrackingChange && resourceTrackingChange({ tracking: { widgetId } });
				publish(act);
			},
			onkeydown: (event: KeyboardEvent) => {
				switch (event.key) {
					case Keys.Enter:
					case Keys.Space:
					case Keys.Spacebar:
						event.preventDefault();
						resourceTrackingChange && resourceTrackingChange({ tracking: { widgetId } });
						publish(act);
						break;
				}
			}
		},
		children()
	);
});
